export default ($stateProvider) => {
  $stateProvider
    .state('wrapper.settings-ringtones', {
      url: 'settings-ringtones',
      template: '<nets-ringtones></nets-ringtones>',
    });
};
